import axiosInstance from "../axiosInterceptor";

export async function getBillingAddress(id) {
  const response = await axiosInstance.get(`/student/getBillingAddress/${id}`);
  const data = response?.data;
  return data;
}
